import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_API_URL;

const getRequestData = async (endpoint, isAdminUser) => {
  const baseUrl = isAdminUser ? `${apiUrl}/admin-user-management` : `${apiUrl}/user-management`;
  const url = `${baseUrl}/${endpoint}`;

  return url;
};

const fetchUserChangeHistory = async (email, isAdminUser) => {
  const endpoint = isAdminUser ? "get-admin-change-history" : "get-user-change-history";
  const baseUrl = await getRequestData(endpoint, isAdminUser);
  const url = `${baseUrl}?email=${email}`;

  let hasToken = true;
  let tokenUrl = url;
  const data = [];

  while (hasToken) {
    const res = await fetchChangeHistoryBatch(tokenUrl);

    if (res?.items) {
      data.push(...res.items);
    }

    if (res?.nextToken) {
      tokenUrl = `${url}&nextToken=${res.nextToken}`;
    } else {
      hasToken = false;
    }
  }

  return data;
};

const fetchChangeHistoryBatch = async (url) => {
  const data = await httpClient.get(url);

  return data?.data;
};

const userChangeHistoryService = { fetchUserChangeHistory };

export default userChangeHistoryService;
